'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';

import { Refresh } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Box, Stack, Container, Typography } from '@mui/material';

import Image from '../../../../components/image';
import { useLocales } from '../../../../locales';
import { ComponentTypeProps } from '../../../../types/page-generator';

const CryptoWallet: FC<ComponentTypeProps> = ({ block }) => {
  const { currentLang } = useLocales();
  const router = useRouter();

  const myCards = [
    {
      id: 1,
      image: '/assets/images/tether.png',
      name: 'USDT(POLYGON)',
      info: '0.93',
      status: 'Approved',
    },
    {
      id: 2,
      image: '/assets/images/tether.png',
      name: 'USDT(TRC-20)',
      info: '0.00',
      status: 'Canceled',
    },
  ];

  const firstStop = block?.settings?.firstGradientColorStop
    ? `${block?.settings?.firstGradientColorStop}%`
    : '40%';
  const secondStop = block?.settings?.secondGradientColorStop
    ? `${block?.settings?.secondGradientColorStop}%`
    : '100%';

  const colorGradient = block?.settings?.addGradientStyle
    ? `linear-gradient(90deg, ${block?.settings?.firstGradientColor} ${firstStop}, ${block?.settings?.secondGradientColor} ${secondStop} )`
    : '';

  return (
    <Container maxWidth="sm" sx={{ p: 0 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
          flexDirection: currentLang.value === 'he' ? 'row-reverse' : 'row',
        }}
      >
        <Stack direction={currentLang.value === 'he' ? 'row-reverse' : 'row'} alignItems="center">
          <IconButton color="inherit" onClick={() => router.back()}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h6">Crypto Wallet</Typography>
        </Stack>
        <IconButton color="inherit">
          <Refresh />
        </IconButton>
      </Box>
      <Stack width={1} gap={2}>
        {myCards.map((card, id) => (
          <Stack
            key={id}
            direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
            width={1}
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: block?.settings?.addGradientStyle
                ? colorGradient
                : block?.settings?.cardColor || '#2b1d36',
              borderRadius: '20px',
              p: 2,
              position: 'relative',
              cursor: 'pointer',
            }}
          >
            <Image src={card.image} />
            <Stack>
              <Typography sx={{ color: 'white' }}>{card.name}</Typography>
            </Stack>
            <Typography sx={{ color: '#F5F5F5' }}>{card.info}</Typography>
          </Stack>
        ))}
      </Stack>
    </Container>
  );
};

export default CryptoWallet;
